import {UI} from "../../../../../stem-core/ui/UIBase";

import {BasePanelPage} from "../../../PanelPage";
import {PaymentMethod} from "../../../../../client/state/PaymentMethodStore";
import {Messages} from "../../../../Messages";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {autoredraw} from "../../../../../stem-core/decorators/AutoRedraw";
import {FlowInputIntent} from "../../../flows/steps/BaseFlowStep.jsx";
import {ChooseCardComponent} from "./components/ChooseCardComponent.jsx";
import {AddPaymentMethodComponent} from "./components/AddPaymentMethodComponent.jsx";
import {Flow} from "../../../flows/Flow.js";
import {BlinkButton} from "../../../../../core/ui/Button.jsx";


@autoredraw(PaymentMethod)
export class PaymentMethodPanel extends BasePanelPage {
    getDefaultOptions(options) {
        return {
            ...super.getDefaultOptions(options),
            title: Messages.paymentDetails,
        };
    }

    getContinueButtonLabel() {
        return Flow.paymentMethod.getContinueButtonLabel({
            [FlowInputIntent.EDIT_VALUE]: Messages.editPaymentDetails,
            [FlowInputIntent.ADD_VALUE]: Messages.addNewPaymentMethod,
        });
    }

    isContinueButtonDisabled() {
        return !(this.paymentMethodInput?.isValid());
    }

    @wrapInSpinner
    async handleContinueButtonClick() {
        const paymentMethod = await this.paymentMethodInput.getPaymentMethod();

        await Flow.paymentMethod.selectValue(paymentMethod);
    }

    render() {
        const {styleSheet} = this;

        const PaymentMethodInputClass = Flow.paymentMethod.getInputComponentClass({
            [FlowInputIntent.CHOOSE_VALUE]: ChooseCardComponent,
            [FlowInputIntent.ADD_VALUE]: AddPaymentMethodComponent,
        });

        return [
            <PaymentMethodInputClass
                ref="paymentMethodInput"
                onChange={() => this.redraw()}
                initialValue={Flow.paymentMethod.selectedValue}
                hideActiveCard={true}
                onAddCard={() => Flow.paymentMethod.enterNewValue()}
                entry={Flow.paymentMethod.entry}
            />,

            <BlinkButton
                ref="button"
                className={styleSheet.actionButton}
                disabled={this.isContinueButtonDisabled()}
                label={this.getContinueButtonLabel()}
                onClick={() => this.handleContinueButtonClick()}
            />,

            Flow.paymentMethod.renderBackButton(),
        ];
    }

    onMount() {
        super.onMount();
        this.redraw(); // TODO @input needed for the button to not be disabled
    }
}
